import React from 'react';
import ExpanderBase from './ExpanderBase';
import { 
	func,
	string,
} from 'prop-types';
import style, {ArrowExpanderStyle} from './style';

const ArrowExpander = ({title,renderAtExpanded,cookieId,...props}) =>{
	const RenderAtClosed = ({onClick})=> (
		<div {...props}>
			<style.TextButton onClick={onClick}>
				<ArrowExpanderStyle.MenuRightIcon/> {title}
        
			</style.TextButton>
		</div>);
	const RenderAtExpanded = ({onClick})=> (
		<div {...props}>
			<style.TextButton onClick={onClick}>
				<ArrowExpanderStyle.MenuDownIcon/> {title}        
			</style.TextButton>
			<style.Container>
				{renderAtExpanded()}
			</style.Container>
		</div>
	);
	return (
		<ExpanderBase 
			cookieId={cookieId}
			renderAtClosed = {RenderAtClosed}  
			renderAtExpanded = {RenderAtExpanded}
		/>
	);
};

ArrowExpander.propTypes = {
	renderAtExpanded : func.isRequired,
	title : string,
	cookieId : string
};
export default ArrowExpander;